// extracted by mini-css-extract-plugin
export default {"card":"x5-z"};